import React, { useState, useEffect } from 'react'
import { DatePicker, Button } from 'antd'
import lodash from 'lodash'
import { getDateDifferences } from '../../../../utils/dates'
import { useTranslation } from 'react-i18next'
import * as moment from 'moment'

let localDates = []
const maxDaysSelected = 150

const Calendar = ({ dates, setDates, showDrawerCapacity }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)
  const [startDayElementPressed, setStartDayElementPressed] = useState(null)
  const [endDayElementPressed, setEndDayElementPressed] = useState(null)

  const handleDateArray = ({ date, isChecked }) => {
    if (localDates.length < maxDaysSelected || !isChecked) {
      let newDateArray = [...localDates]
      if (isChecked === true && moment(date).isSameOrAfter(moment(), 'day')) {
        newDateArray.push(date)
      } else {
        lodash.remove(newDateArray, (item) => {
          return item === date
        })
      }
      localDates = newDateArray
      setDates(localDates)
      setStartDayElementPressed(null)
      setEndDayElementPressed(null)
    }
  }

  const handleOpenChange = (open) => {
    if (open) setOpen(open)
  }

  const dateRender = (currentDate) => {
    let disabled = 'false'
    let addSelectedDateClass = ''
    const style = {}
    const stringDate = currentDate.format('YYYY-MM-DD')

    if (localDates.indexOf(stringDate) > -1) {
      addSelectedDateClass = 'selectedDate'
    }

    return (
      <div
        data-disabled={disabled}
        data-date={stringDate}
        className={`ant-calendar-date multi-date ${addSelectedDateClass}`}
        style={style}
      >
        {currentDate.date()}
      </div>
    )
  }

  const dateFooterContent = (_mode) => {
    return (
      <div align='left'>
        <Button
          className='clean-btn'
          onClick={() => {
            localDates = []
            setDates([])
          }}
          type='link'
          size='small'
        >
          {t('resources.capacity.edit-form.calendar.clean')}
        </Button>
      </div>
    )
  }

  function datesHandle(dayElement) {
    const dataSelected = dayElement ? dayElement : this.childNodes[0]
    const {
      dataset: { date, disabled }
    } = dataSelected
    if (disabled === 'false' && moment(date).isSameOrAfter(moment(), 'day')) {
      let isChecked = false
      dataSelected.classList.toggle('selectedDate')
      if (dataSelected.classList.contains('selectedDate')) {
        isChecked = true
      }
      handleDateArray({ date, isChecked })
    }
  }

  function removeEventListeners() {
    const dataPicker = document.querySelector('.ant-picker-panel-container')
    if (dataPicker) {
      dataPicker.classList.remove('resource-capacity-calendar')
      const elements = document.getElementsByClassName('multi-date')
      Array.from(elements).forEach(function (element) {
        element.removeEventListener('click', datesHandle)
      })
    }
  }

  function loadEventListeners() {
    setTimeout(function () {
      const dataPicker = document.querySelector('.ant-picker-panel-container')
      if (dataPicker) {
        dataPicker.classList.add('resource-capacity-calendar')
        const elements = document.getElementsByClassName('ant-picker-cell')
        Array.from(elements).forEach(function (element) {
          element.onmousedown = function () {
            setStartDayElementPressed(this.childNodes[0])
          }
          element.onmouseup = function () {
            setEndDayElementPressed(this.childNodes[0])
          }
        })
      }
    }, 100)
  }

  function loadDataPickerEvents() {
    setTimeout(function () {
      const nextButton = document.querySelector('.ant-picker-header-next-btn')
      const prevButton = document.querySelector('.ant-picker-header-prev-btn')
      if (nextButton && prevButton) {
        nextButton.addEventListener('click', loadEventListeners)
        prevButton.addEventListener('click', loadEventListeners)
      }
    }, 100)
  }

  const disabledDate = (currentDate) => {
    let isDisabled = false
    if (localDates.length >= maxDaysSelected) {
      const formattedCurrentDate = currentDate.format('YYYY-MM-DD')
      if (!localDates.includes(formattedCurrentDate)) {
        isDisabled = true
      }
    }
    const today = moment()
    return currentDate && (currentDate < today.startOf('day') || isDisabled)
  }

  useEffect(() => {
    if (dates.length === 0) {
      localDates = []
    }
    if (showDrawerCapacity) {
      loadEventListeners()
      loadDataPickerEvents()
    }
    return (_) => {
      setOpen(false)
      removeEventListeners()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDrawerCapacity])

  useEffect(() => {
    if (startDayElementPressed && endDayElementPressed) {
      let startDate = startDayElementPressed.getAttribute('data-date')
      let endDate = endDayElementPressed.getAttribute('data-date')
      const dateRange = getDateDifferences(startDate, endDate)
      dateRange.forEach((date) => {
        let dayElement = startDayElementPressed.cloneNode(true)
        dayElement.setAttribute('data-date', date)
        dayElement.innerHTML = moment(date).format('DD')
        datesHandle(dayElement)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDayElementPressed])

  return (
    <DatePicker
      className='capacity-form-calendar'
      showToday={false}
      open={open}
      onOpenChange={handleOpenChange}
      dateRender={dateRender}
      renderExtraFooter={dateFooterContent}
      disabledDate={disabledDate}
    />
  )
}

export default Calendar
